import type {
  ActionBarApi,
  ActionBarItemProps,
  ActionBarProps,
} from '@workwave-tidal/core/components/ActionBar'

import { type Dispatch, useCallback, useRef } from 'react'
import type { LocationEditorActions } from '../types'

import { gis } from '@/server-data'
import { copyToClipboard } from '@/utils'

import { LocationEditorProps } from '../types'

export function useActionBarActions(
  props: LocationEditorProps,
  dispatch: Dispatch<LocationEditorActions>,
): ActionBarProps {
  const actionBarApi = useRef<ActionBarApi>(null)
  const {
    onShowAdjustAddressModal,
    onCopyCoordinates: onCopyCoordinatesCallback,
    location,
    disabled,
  } = props

  const onClick = useCallback(
    ({ id }: Pick<ActionBarItemProps, 'id' | 'label'>) => {
      if (!id) return

      dispatch({ type: 'actionBar:click' })

      switch (id) {
        case 'adjust-address':
          onShowAdjustAddressModal()
          break

        case 'copy-coordinates': {
          copyToClipboard(gis.latLngToUrlValue(location.latLng))
          onCopyCoordinatesCallback?.()
          break
        }
      }

      actionBarApi.current?.close()
    },
    [onCopyCoordinatesCallback, location, onShowAdjustAddressModal],
  )

  return {
    actions: actionBarApi,
    onClick,
    disabled,
  }
}
